import { render, staticRenderFns } from "./loyalty-program-setting-form.vue?vue&type=template&id=350c4fd0"
import script from "./loyalty-program-setting-form.vue?vue&type=script&lang=js"
export * from "./loyalty-program-setting-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports